import { IconButton, Paper } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { DeleteForeverTwoTone, EditTwoTone } from '@material-ui/icons';
import React, { Component } from 'react';

export default class DatasheetView extends Component {
    render() {
        let fieldspecs = this.props.fieldspecs;

        if (this.props.delete){
            fieldspecs.push({
                field: 'delete',
                headerName: this.props.deleteHeaderName,
                width: 73,
                headerAlign: 'center',
                sortable: false,
                renderCell: (parms) => (
                    <IconButton 
                        onClick={()=>this.props.handleDelete(parms)} 
                    >
                        <DeleteForeverTwoTone/>
                    </IconButton>
                )
            });
        }

        if (this.props.edit){
            fieldspecs.unshift({
                field: 'edit',
                headerName: 'Edit',
                headerAlign: 'center',
                width: 73,
                sortable: false,
                renderCell: (parms) => (
                    <IconButton 
                        onClick={()=>this.props.handleEdit(parms)}  
                    >
                        <EditTwoTone/>
                    </IconButton>
                )
            });
        }

        return (
            
            <Paper 
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    height: this.props.height,
                    width:this.props.width?this.props.width: '100%',
                }}
            >
                <DataGrid 
                    rows={this.props.dataset}
                    columns={this.props.fieldspecs}
                    // pageSize={this.props.pagesize? this.props.pagesize : 24} //24 hides page record no.
                    autoPageSize={this.props.autoPageSize? true : false}
                    autoHeight={this.props.height? false : true}
                    hideFooterSelectedRowCount
                    // autoHeight
                    // onRowClick={this.handleRowClick}
                    showToolbar
                    // rowHeight={50}
                    // disableSelectionOnClick
                    density='compact'
                    // disableDensitySelector
                    disableColumnMenu
                    disableSelectionOnClick
                    // disableColumnSelector
                    loading={this.props.loading? true : false}
                    checkboxSelection={this.props.checkboxSelection? true : false}
                    onSelectionModelChange={(selectedIDs)=>{this.props.handleSelectionChange(selectedIDs)}}
                />
            </Paper>
        );
    }
}